import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MapOfEurope from './MapOfEurope';

function fillColor(country, isHover) {
  if(country.isSchengen) {
    return isHover ? '#f8d347' : '#fbea9f';
  }
  else {
    return '#b2b2b2';
  }
}

class HomepageMap extends Component {
  render() {
    const { isFetching } = this.props.store.state;
    const { language } = this.props;

    if(isFetching) {
      return null;
    }

    return (
      <MapOfEurope
        store={this.props.store}
        width={1000}
        fillColor={fillColor}
        language={language}
      />
    );
  }
}

HomepageMap.propTypes = {
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.shape({
        cz: PropTypes.string,
        en: PropTypes.string,
        ru: PropTypes.string,
      }),
      threeLetterCode: PropTypes.string,
    }),
  ),
};

export default HomepageMap;



// WEBPACK FOOTER //
// ./src/maps/HomepageMap.js